export default [
    {
        "fa": "fas fa-hand-pointer",
        "value": "Self-Requesting Screening Mammograms",
        "linkTo": "https://arizonadiagnosticradiology.com/mammogramsmadeeasy"
    },
    {
        "fa": "fab fa-facebook",
        "value": "Facebook",
        "linkTo": "https://www.facebook.com/ArizonaRadiology"
    },
    {
        "fa": "fab fa-instagram",
        "value": "Instagram",
        "linkTo": "https://www.instagram.com/arizonaradiology/"
    },
    {
        "fa": "fab fa-tiktok",
        "value": "TikTok",
        "linkTo": "https://www.tiktok.com/@arizonaradiology"
    },
    {
        "fa": "fa-brands fa-threads",
        "value": "Threads",
        "linkTo": "https://www.threads.net/@arizonaradiology"
    },
    {
        "fa": "fa-brands fa-x-twitter",
        "value": "Twitter",
        "linkTo": "https://twitter.com/AZ_Radiology"
    },
    {
        "fa": "fab fa-linkedin",
        "value": "Linkedin",
        "linkTo": "https://www.linkedin.com/company/arizonaradiology"
    },
    {
        "fa": "fab fa-youtube",
        "value": "YouTube",
        "linkTo": "https://www.youtube.com/@arizonaradiology"
    },
    {
        "fa": "fas fa-globe",
        "value": "Our Website",
        "linkTo": "https://www.ArizonaDiagnosticRadiology.com"
    },
    {
        "fa": "fas fa-globe",
        "value": "Enhanced Breast Cancer Detection (EBCD)",
        "linkTo": "https://myebcdmammo.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=my_ebcd"
    },
    {
        "fa": "fas fa-microphone",
        "value": "Your Body Podcast",
        "linkTo": "https://www.yourbodyshow.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=your_body_show"
    },
    {
        "fa": "fa fa-briefcase",
        "value": "Careers",
        "linkTo": "https://careers.radnet.com/careers-home/jobs?state=Arizona"
    },
    {
        "fa": "fas fa-lungs",
        "value": "Lung Cancer Screening",
        "linkTo": "https://www.arizonadiagnosticradiology.com/services/low-dose-lung-ct-scan"
    },
    {
        "fa": "fas fa-globe",
        "value": "XRayHours.com",
        "linkTo": "https://xrayhours.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=xray_hours/az"
    },
    {
        "fa": "fas fa-globe",
        "value": "Prostate Program",
        "linkTo": "https://prostate.radnetimaging.com/"
    },
    {
        "fa": "fas fa-ribbon",
        "value": "High-Risk Breast Program",
        "linkTo": "https://www.arizonadiagnosticradiology.com/services/genetic-testing/"
    }
]